import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import headerImg from "../assets/img/ashu3.jpg";
import headerImg from "../assets/img/123.png";
import { Button } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { ExperienceSection } from "./ExperienceSection";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [
    "GenAI Full Stack Developer",
    "Web3 Explorer",
    "Programmer",
  ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  const resumeLink =
    //  "https://drive.google.com/file/d/1k4N6-fNOYLzy5YwJ-xuYgBbU1DWrrzEc/view?usp=sharing";
    // "https://drive.google.com/file/d/1eZthNCkHf9MecUoA4jBczpvczGVR49Yn/view?usp=sharing";
    "https://drive.google.com/file/d/1ucqTfxz4HF-o1cteuUaL9T6dWY643Ipo/view?usp=sharing";

  const viewResume = () => {
    window.open(resumeLink, "_blank"); // Opens in a new tab
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <span className="tagline ">Welcome to my Portfolio</span>
                  <h1>
                    <span className="greet">
                      {" "}
                      {`Hi, I am`} <br />
                      {`Ashutosh Kumar`}
                    </span>
                    <br />
                    <span
                      className="txt-rotate"
                      data-period="1000"
                      data-rotate='["GenAI Full Stack Developer", "Web3 Explorer", "Programmer" ]'
                    >
                      <span className="wrap"> {text}</span>
                    </span>
                  </h1>
                  <p>
                    {/* Motivated and versatile, I thrive on new challenges.
                    Learning fuels my passion for excellence, leading to
                    high-quality results. My positive attitude and growth
                    mindset make me ready to contribute and achieve great
                    things. */}
                    A developer building Scalable Web Products with MERN, AI &
                    Web3.
                  </p>
                  <Button
                    onClick={viewResume}
                    variant="primary"
                    className="me-2"
                    target="_blank"
                  >
                    Resume <ArrowRightCircle size={25} />
                  </Button>
                  {/* <button onClick={viewResume}>
                    Find my Resume <ArrowRightCircle size={25} />
                  </button> */}
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            {/* <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                >
                  <img src={headerImg} alt="Header Img" />
                </div>
              )}
            </TrackVisibility> */}

            <div className="imgContainer">
              <img src={headerImg} alt="Header Img" className="mypic" />
            </div>
          </Col>
        </Row>
      </Container>
      <ExperienceSection />
    </section>
  );
};
